import { getAuthProviderUrl } from '../utils/auth_url';
import AuthUtils from '../auth/auth_utils';

const makeAuthRequest = async (endpoint, method, body = null) => {
    const authProviderUrl = getAuthProviderUrl();
    const cleanAuthProviderUrl = authProviderUrl.replace(/\/$/, '');
    const response = await fetch(`${cleanAuthProviderUrl}/${endpoint}`, {
        method,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${AuthUtils.GetAuthToken()}`
        },
        body: body ? JSON.stringify(body) : null
    });

    if (!response.ok) {
        throw new Error('Auth request failed');
    }

    return response.json();
};

const changePassword = (payload) => {
    return makeAuthRequest('user/password', 'PATCH', payload);
};

export const authData = {
    changePassword
}; 